import styled from 'styled-components';
import GlobalPromoMap from '../../../assets/images/pluvaAutoLanding/global-promo_map.png';
import GlobalWorking from '../../../assets/images/pluvaAutoLanding/global-promo_working.gif';
import PromoTransplanter from '../../../assets/images/pluvaAutoLanding/global-promo_transplanter.png';
import PromoTractor from '../../../assets/images/pluvaAutoLanding/global-promo_tractor.png';
import { PointBadge } from './PointBadge';

export const GlobalVerificationPromoSection = () => {
  return (
    <Container>
      <TopSection>
        <TitleSection>
          <PointBadge title={'전국 곳곳 끊김없이'} />
          <Title>{'트랙터 & 이앙기\n한국과 일본에서 검증완료!'}</Title>
        </TitleSection>
        <Image src={GlobalPromoMap} />
        <Description>{'대표적인 농업지역부터\n대한민국 끝단까지\n한국 뿐만 아니라 일본까지'}</Description>
      </TopSection>
      <CardGroup>
        <GlobalAndPromoBox>
          <GlobalImage src={GlobalWorking} />

          <DescriptionWrapper>
            <DescriptionText>{'플루바오토가 이미 설치된 트랙터/이앙기가 곳곳을 누비고 있습니다.'}</DescriptionText>
          </DescriptionWrapper>
        </GlobalAndPromoBox>

        <GlobalAndPromoBox>
          <PromoImageWrap>
            <PromoImage src={PromoTransplanter} />
            <PromoImage src={PromoTractor} />

            <PromoBadge>
              <PromoBadgeText>{'1+1 설치 시 할인가 지원'}</PromoBadgeText>
            </PromoBadge>
          </PromoImageWrap>
          <DescriptionWrapper>
            <DescriptionText>{'트랙터와 이앙기에 1+1 설치 시 대폭 할인된 프로모션 가격도 지원!'}</DescriptionText>
          </DescriptionWrapper>
        </GlobalAndPromoBox>
      </CardGroup>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0px 24px 48px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */

  white-space: pre-line;
`;

const Image = styled.img`
  width: 200px;
`;

const Description = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: pre-line;
`;

const CardGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const GlobalAndPromoBox = styled.div`
  flex-direction: column;
  gap: var(--radius-large, 16px);

  display: flex;
  padding: 24px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  align-self: stretch;
`;

const DescriptionText = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

const GlobalImage = styled.img`
  border-radius: var(--radius-medium, 8px);
  background: url(${GlobalWorking}) lightgray 50% / cover no-repeat;
`;

const PromoImageWrap = styled.div`
  position: relative;
  display: flex;
  min-height: 180px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const PromoImage = styled.img`
  width: 120px;

  @media screen and (max-width: 340px) {
    width: 100px;
  }
`;

const PromoBadge = styled.div`
  position: absolute;
  left: 10px;
  top: 11px;

  display: flex;
  height: 28px;
  padding: 8px;

  border-radius: 8px;
  background: var(--Light-Scheme-Color-primary-green, #34c77e);

  align-items: center;
  gap: 4px;
`;

const PromoBadgeText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
